import { callPostApi, callDeleteApi, callPutApi, callGetApi } from "./api";

export async function getDeliveryMatrixList(data) {
      try {
            const response = await callPostApi({ url: "delivery-matrix/list", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function deleteDeliveryMatrixList(id) {
      try {
            const response = await callDeleteApi({ url: "delivery-matrix/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function addDeliveryMatrix(data) {
      try {
            const response = await callPostApi({ url: "delivery-matrix/", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function getDeliveryMatrixById(id) {
      try {
            const response = await callGetApi({ url: "delivery-matrix/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function updateDeliveryMatrix(data, id) {
      try {
            const response = await callPutApi({ url: "delivery-matrix/" + id, body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function getDeliveryMatrixNameList() {
      try {
            const response = await callGetApi({ url: "delivery-matrix/name-list" });
            return response;
      } catch (error) {
            throw error;
      }
}

